export const FORM_ERRORS = {
  emailError: 'Неверный формат почты',
  minError: 'Должно содержать не меньше ${min} символов',
  requiredError: 'Обязательное поле',
};
